namespace TabAurous.SalesOrder {
    export interface SalesOrderItemsForm {
        TransId: Serenity.StringEditor;
        TransItemId: Serenity.StringEditor;
        PartyId: Serenity.IntegerEditor;
        BagNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        DesignId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        DesignCode: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        BrandId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        StampId: Serenity.LookupEditor;
        ProductSizeId: CommonProductSizeLookup;
        HasBom: Serenity.BooleanEditor;
        MetalId: Serenity.LookupEditor;
        Attribute: Serenity.StringEditor;
        KaratId: Serenity.LookupEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: WeightEditor;
        MetalColorId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        SieveId: StoneSieveLookup;
        GroupSieveId: StoneSieveLookup;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        Lab: Serenity.LookupEditor;
        CertificateNo: Serenity.StringEditor;
        CalcOnId: Serenity.LookupEditor;
        CalcUnitId: Serenity.LookupEditor;
        Pieces: Serenity.IntegerEditor;
        ExportPieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        UnitRate: Serenity.DecimalEditor;
        StoneRate: AmountEditor;
        OtherRate: AmountEditor;
        UnitLabour: Serenity.DecimalEditor;
        FancyCharges: AmountEditor;
        OtherCharges: AmountEditor;
        NetAmount: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        CCGrossAmount: Serenity.DecimalEditor;
        CCNetAmount: Serenity.DecimalEditor;
        MF: Serenity.DecimalEditor;
        MFAmount: Serenity.DecimalEditor;
        Line_No: Serenity.StringEditor;
        HSN: Serenity.LookupEditor;
        TaxCode: Serenity.LookupEditor;
        NetWeight: WeightEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: WeightEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: WeightEditor;
        OtherPieces: Serenity.IntegerEditor;
        OtherWeight: WeightEditor;
        MetalAmount: Serenity.DecimalEditor;
        DiamondAmount: Serenity.DecimalEditor;
        StoneAmount: Serenity.DecimalEditor;
        OtherAmount: Serenity.DecimalEditor;
        UnitCost: Serenity.DecimalEditor;
        DiscountPer: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        WstPer: Serenity.DecimalEditor;
        WstWt: WeightEditor;
        DepartmentId: Serenity.IntegerEditor;
        Remarks: Serenity.StringEditor;
        IsDisabled: Serenity.BooleanEditor;
        ServerDate: Serenity.DateEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        SpecialRemark: Serenity.StringEditor;
        UserDescription: Serenity.StringEditor;
        AckStatus: Serenity.IntegerEditor;
        DeliveryDate: Serenity.DateEditor;
        CompanyId: Serenity.IntegerEditor;
        BagStatus: Serenity.StringEditor;
        CostMethodId: Serenity.LookupEditor;
        ImageName: Serenity.ImageUploadEditor;
        BOMDetails: SalesOrderBOMEditor;
        LaborDetails: SalesOrderLaborEditor;
    }

    export class SalesOrderItemsForm extends Serenity.PrefixedContext {
        static formKey = 'SalesOrder.SalesOrderItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SalesOrderItemsForm.init)  {
                SalesOrderItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = CommonCategoryLookup;
                var w4 = CommonSubCategoryLookup;
                var w5 = CommonProductSizeLookup;
                var w6 = s.BooleanEditor;
                var w7 = s.DecimalEditor;
                var w8 = WeightEditor;
                var w9 = StoneSieveLookup;
                var w10 = AmountEditor;
                var w11 = s.DateEditor;
                var w12 = s.ImageUploadEditor;
                var w13 = SalesOrderBOMEditor;
                var w14 = SalesOrderLaborEditor;

                Q.initFormType(SalesOrderItemsForm, [
                    'TransId', w0,
                    'TransItemId', w0,
                    'PartyId', w1,
                    'BagNo', w0,
                    'SKU', w0,
                    'RefNo', w0,
                    'ItemTypeId', w1,
                    'ProductId', w0,
                    'DesignId', w0,
                    'ProductTypeId', w2,
                    'ProductCode', w0,
                    'ProductName', w0,
                    'DesignCode', w0,
                    'AttributeId', w0,
                    'CategoryId', w3,
                    'SubCategoryId', w4,
                    'BrandId', w2,
                    'SuperTypeId', w2,
                    'CollectionId', w2,
                    'StampId', w2,
                    'ProductSizeId', w5,
                    'HasBom', w6,
                    'MetalId', w2,
                    'Attribute', w0,
                    'KaratId', w2,
                    'Purity', w7,
                    'PureWeight', w8,
                    'MetalColorId', w2,
                    'ShapeId', w2,
                    'StoneColorId', w2,
                    'QualityId', w2,
                    'StoneSizeId', w2,
                    'SieveId', w9,
                    'GroupSieveId', w9,
                    'StoneCutId', w2,
                    'StonePolishId', w2,
                    'StoneSymmetryId', w2,
                    'StoneFluorescenceId', w2,
                    'StoneCuletId', w2,
                    'StoneGirdleId', w2,
                    'StoneTable', w0,
                    'StoneDepth', w0,
                    'LotNo', w0,
                    'Lab', w2,
                    'CertificateNo', w0,
                    'CalcOnId', w2,
                    'CalcUnitId', w2,
                    'Pieces', w1,
                    'ExportPieces', w1,
                    'Weight', w8,
                    'UnitRate', w7,
                    'StoneRate', w10,
                    'OtherRate', w10,
                    'UnitLabour', w7,
                    'FancyCharges', w10,
                    'OtherCharges', w10,
                    'NetAmount', w7,
                    'GrossAmount', w7,
                    'CCGrossAmount', w7,
                    'CCNetAmount', w7,
                    'MF', w7,
                    'MFAmount', w7,
                    'Line_No', w0,
                    'HSN', w2,
                    'TaxCode', w2,
                    'NetWeight', w8,
                    'DiamondPieces', w1,
                    'DiamondWeight', w8,
                    'StonePieces', w1,
                    'StoneWeight', w8,
                    'OtherPieces', w1,
                    'OtherWeight', w8,
                    'MetalAmount', w7,
                    'DiamondAmount', w7,
                    'StoneAmount', w7,
                    'OtherAmount', w7,
                    'UnitCost', w7,
                    'DiscountPer', w7,
                    'Discount', w7,
                    'WstPer', w7,
                    'WstWt', w8,
                    'DepartmentId', w1,
                    'Remarks', w0,
                    'IsDisabled', w6,
                    'ServerDate', w11,
                    'RefTransItemId', w0,
                    'RefTransId', w0,
                    'Remark', w0,
                    'SpecialRemark', w0,
                    'UserDescription', w0,
                    'AckStatus', w1,
                    'DeliveryDate', w11,
                    'CompanyId', w1,
                    'BagStatus', w0,
                    'CostMethodId', w2,
                    'ImageName', w12,
                    'BOMDetails', w13,
                    'LaborDetails', w14
                ]);
            }
        }
    }
}
